// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__5CyKe","wrapperBtn":"Tabs_wrapperBtn__vWvzW","btn":"Tabs_btn__Ys8Hc","list":"Tabs_list__5+pPQ","item":"Tabs_item__atVom"};